import React, { useState } from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import PeriodSelector from './PeriodSelector';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchSlowRequests } from '../api/monitoringApi';

const Table = styled.table`width: 100%; border-collapse: collapse; font-size: 13px;`;
const Th = styled.th`text-align: left; padding: 6px 8px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; color: #6b7280; font-weight: 600;`;
const Td = styled.td`padding: 6px 8px; border-bottom: 1px solid #f3f4f6; color: #374151;`;

const Select = styled.select`padding: 4px 8px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 12px;`;
const Actions = styled.div`display: flex; gap: 8px; align-items: center;`;

function fmtTime(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  return d.toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export default function SlowRequestsPanel({ refreshKey }) {
  const [period, setPeriod] = useState('24h');
  const [threshold, setThreshold] = useState(1000);
  const { data, isLoading, error } = useMonitoringData(
    () => fetchSlowRequests(period, threshold, 20), [period, threshold, refreshKey]
  );

  return (
    <Panel title="느린 요청" isLoading={isLoading} error={error}
      actions={
        <Actions>
          <Select value={threshold} onChange={e => setThreshold(Number(e.target.value))}>
            <option value={500}>500ms</option>
            <option value={1000}>1s</option>
            <option value={3000}>3s</option>
            <option value={5000}>5s</option>
          </Select>
          <PeriodSelector value={period} onChange={setPeriod} />
        </Actions>
      }>
      <div style={{ overflowX: 'auto' }}>
        <Table>
          <thead><tr><Th>시간</Th><Th>Method</Th><Th>URL</Th><Th>소요시간</Th><Th>상태</Th><Th>고객</Th></tr></thead>
          <tbody>
            {data?.map((r, i) => (
              <tr key={i}>
                <Td>{fmtTime(r.timestamp)}</Td>
                <Td>{r.method}</Td>
                <Td>{r.url}</Td>
                <Td style={{ fontWeight: 700, color: r.run_time_ms > 3000 ? '#ef4444' : '#f59e0b' }}>{r.run_time_ms}ms</Td>
                <Td>{r.result_code}</Td>
                <Td>{r.client_name || r.client_email || '-'}</Td>
              </tr>
            ))}
            {data?.length === 0 && <tr><Td colSpan={6} style={{ textAlign: 'center', color: '#9ca3af' }}>느린 요청이 없습니다</Td></tr>}
          </tbody>
        </Table>
      </div>
    </Panel>
  );
}
